<app-tab-layout [loading]="loading()" [error]="error">
  <div class="tab-content">
    <app-api-table
      [endpoint]="'/activities/tables/me'"
      [name]="dictionaryService.get('name')"
      [chartColumn]="'Type'"
    >
    </app-api-table>
  </div>
</app-tab-layout>
